<template>
    <div class="queryBox">
        <div class="query_div">
            <h3 class="title_h3">
                <img src="https://zyprogram.xinchacha.com/xiansuo/pc/index_title.png" alt="" srcset="">
            </h3>
            <div class="table_box_div">
                <div class="item_Dom" @click="tabs(1)">
                    <img v-if="btnType != 1" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon1.png" alt="" srcset="">
                    <img v-if="btnType == 1" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon1_c.png" alt="" srcset="">
                    <div :class="[btnType == 1? 'div_name click':'div_name']">
                        查推广
                    </div>
                </div>
                <div class="item_Dom" @click="tabs(2)">
                    <img v-if="btnType != 2" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon2.png" alt="" srcset="">
                    <img v-if="btnType == 2" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon2_c.png" alt="" srcset="">
                    <div :class="[btnType == 2? 'div_name click':'div_name']">
                        查空壳
                    </div>
                </div>
                <!-- <div class="item_Dom" @click="tabs(3)">
                    <img v-if="btnType != 3" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon3.png" alt="" srcset="">
                    <img v-if="btnType == 3" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon3_c.png" alt="" srcset="">
                    <div :class="[btnType == 3? 'div_name click':'div_name']">
                        空壳APP
                    </div>
                </div> -->
                <div class="item_Dom" @click="tabs(4)">
                    <img v-if="btnType != 4" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon4.png" alt="" srcset="">
                    <img v-if="btnType == 4" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon4_c.png" alt="" srcset="">
                    <div :class="[btnType == 4? 'div_name click':'div_name']">
                        查备案
                    </div>
                </div>
                <!-- <div class="item_Dom" @click="tabs(5)">
                    <img v-if="btnType != 5" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon5.png" alt="" srcset="">
                    <img v-if="btnType == 5" src="https://zyprogram.xinchacha.com/xiansuo/pc/icon/icon5_c.png" alt="" srcset="">
                    <div :class="[btnType == 5? 'div_name click':'div_name']">
                        备案数据分析
                    </div>
                </div> -->
            </div>
            <div class="query_box_Dom" v-if="btnType == 1">
                <input v-model="queryStr" type="text" :placeholder="alertStr1" @keyup.enter="queryFn()"/>
                <div class="btn" @click="queryFn()">免费查询</div>
            </div>
            <div class="query_box_Dom" v-if="btnType == 2">
                <input v-model="queryStr" type="text" :placeholder="alertStr2" @keyup.enter="queryFn()"/>
                <div class="btn" @click="queryFn()">免费查询</div>
            </div>
            <div class="query_box_Dom" v-if="btnType == 4">
                <input v-model="queryStr" type="text" :placeholder="alertStr3" @keyup.enter="queryFn()"/>
                <div class="btn" @click="queryFn()">免费查询</div>
            </div>
            <div class="resou">
                <div>热门搜索: </div>
                <div v-for="(item,index) in lineArr" :key="index">
                    <a :href="'/wordsList?text='+item" :alt="item" target="_blank">{{item}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'vQueryBox',
    data(){
        return{
            btnType:1,
            queryStr:'',
            alertStr1:"请输入单位名称或域名或备案号，请勿使用电子域名或者带http://www等字符查询",
            alertStr2:"主办单位名称或主体备案号或核查管理批次",
            alertStr3:"请输入单位名称或域名或备案号，请勿使用电子域名或者带http://www等字符查询",
            lineArr:[]
        }
    },
    methods:{
        queryFn(){
            var data = {
                tableType:this.btnType,
                queryStr:this.queryStr
            };
            this.$emit('queryData',data);
        },
        tabs(val){
            if (parseInt(val) == 2) {
                return this.$router.push({
                    path:'/emptyshell',
                    query:{
                        text:''
                    }
                });
            } else {
                this.btnType = parseInt(val);
                this.$emit('tabFun',this.btnType);
            }
        },
        getHot(){
            var _this = this;
            this.getRequest('api/clue/hot').then(res=>{
				var data = res.data;
				if(data.status == 200){
					_this.lineArr = data.obj == undefined? []:data.obj;
				}
			})
        }
    },
    mounted(){
        this.getHot();
    }
}
</script>
<style lang="scss" scoped>
input:focus{
    outline: none;
}
.queryBox{
    width: 100%;
    height: auto;
    background-color: #4192FE;
    >div.query_div{
        min-height: 450px;
        margin: 0 auto;
        background-image: url('https://zyprogram.xinchacha.com/xiansuo/pc/query_bg.png');
        background-repeat: no-repeat;
        background-position: 100% 100%;
        padding-top: 1px;
        box-sizing: border-box;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >h3.title_h3{
            width: 100%;
            height: auto;
            font-size: 54px;
            font-weight: 400;
            color: #fff;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 50px;
            >img{
                width: auto;
                height: 54px;
                display: block;
                margin: 0 auto;
            }
        }
        >div.table_box_div{
            width: 80%;
            height: auto;
            display: flex;
            justify-content: space-evenly;
            margin: 0 auto 36px;
            >div.item_Dom{
                width: auto;
                cursor: default;
                >img{
                    width: 50px;
                    height: 50px;
                    display: block;
                    margin: 0 auto;
                }
                >div.div_name{
                    width: auto;
                    height: auto;
                    color: #C6DEFE;
                    font-size: 18px;
                    margin-top: 10px;
                }
                >div.div_name.click{
                    color: #fff;
                }
            }
        }
        >div.query_box_Dom{
            width: 100%;
            height: 63px;
            background: #FFFFFF;
            box-shadow: 0px 23px 61px 0px rgba(0, 0, 0, 0.22);
            position: relative;
            >div.btn{
                width: 22%;
                height: 63px;
                line-height: 63px;
                background-color: #1184FF;
                color: #fff;
                text-align: center;
                font-size: 18px;
                position: absolute;
                right: 0;
                top: 0;
            }
            >input{
                width: 78%;
                height: 63px;
                line-height: 63px;
                border: none;
                padding-left: 20px;
                box-sizing: border-box;
                font-size: 18px;
                color: #8C97AC;
            }
        }
        >div.resou{
            width: 100%;
            height: auto;
            display: flex;
            margin-top: 34px;
            >div{
                width: auto;
                height: 40px;
                line-height: 40px;
                font-size: 20px;
                color: #fff;
                margin-left: 10px;
                cursor: default;
                >a{
                    color: #fff;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/query_box.vue